/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React, { useState, useEffect, useCallback } from "react";
import TypingText from "../../../../../components/TypingText";
import TypingIndicator from "../../../../../components/TypingIndicator";
import "./style.css";

// 🎬 RAPID TYPING (Dec 4, 2025): Reduced from 30ms to 15ms for rapid animation
// Configuration for typing speed - unified across all message types
const CEDAR_TYPING_SPEED = 15; // milliseconds per character - rapid but visible typing

// 🚀 PERFORMANCE FIX: Component defined without export, will be exported as memoized version below
const CmpCedarbubble = ({ className, divClassName, text = "Hey, I'm Cedar", enableTyping = true, isFirstMessage = false, status = 'delivered', isStreaming = false, onAnimationComplete }) => {
  const [animationPhase, setAnimationPhase] = useState(isFirstMessage ? 'startup' : 'complete');
  // 🔧 FIX (blank chat): Always start with showTyping=true so text animates immediately.
  // The avatar CSS animation plays independently — no need to block text rendering.
  const [showTyping, setShowTyping] = useState(true);
  const [localIsStreaming, setLocalIsStreaming] = useState(isStreaming); // 🔧 FIX Issue #2: Local streaming state
  
  // 🔧 FIX Issue #2: Sync local streaming state with prop
  useEffect(() => {
    setLocalIsStreaming(isStreaming);
  }, [isStreaming]);
  
  // Determine what to show based on status
  const isThinking = status === 'thinking';
  const isTypingStatus = status === 'typing' || status === 'sending';
  const shouldShowDots = isThinking || (!text && isTypingStatus);
  // 🔧 FIX Issue #1: Don't show fallback if streaming hasn't started yet (empty text + isStreaming)
  const shouldShowText = text && (status === 'delivered' || isTypingStatus);
  const shouldShowFallback = !localIsStreaming; // Only show fallback for non-streaming messages
  
  // 🚨 CRITICAL FIX (Nov 22, 2025): Wrap in useCallback to prevent recreation on every render
  // This callback was being recreated constantly, causing TypingText's useEffect to re-run
  // on every frame (onComplete is in TypingText's dependency array), which restarted the animation
  const handleAnimationComplete = useCallback(() => {
    setLocalIsStreaming(false);
    if (onAnimationComplete) {
      onAnimationComplete();
    }
  }, [onAnimationComplete]);

  useEffect(() => {
    if (isFirstMessage && animationPhase === 'startup') {
      console.log('🎬 CEDARBUBBLE: Starting initial message animation sequence');
      // Phase 1: Avatar container flies in from top (0-1s) - GREEN from start
      setTimeout(() => setAnimationPhase('avatar-container'), 0);
      
      // Phase 2: CC text flies in from right (1-2s)  
      setTimeout(() => setAnimationPhase('cc-text'), 1000);
      
      // Phase 3: Green border flies in from bottom (2-3s)
      setTimeout(() => setAnimationPhase('green-border'), 2000);
      
      // Phase 4: Mark animation complete (3s) - text typing already started immediately
      setTimeout(() => {
        console.log('🎬 CEDARBUBBLE: Avatar animation complete');
        setAnimationPhase('complete');
      }, 3000);
    }
  }, [isFirstMessage, animationPhase]);
  return (
    <div className={`cmp-cedarbubble ${className || ""} ${isFirstMessage ? `startup-animation phase-${animationPhase}` : ''}`}>
      {/* Avatar rectangle - Cedar brand dark green with top-left radius */}
      <div 
        className={`avatar-rectangle ${isFirstMessage ? 'startup-avatar' : ''}`}
        style={{
          backgroundColor: '#1F6C4F', // Always green - no color transition
          background: '#1F6C4F' // Always green - no color transition
        }}
      >
        <div className={`avatar-content ${isFirstMessage ? 'startup-cc' : ''}`}>
          {(animationPhase === 'cc-text' || animationPhase === 'green-border' || animationPhase === 'complete') ? 'CC' : ''}
        </div>
      </div>
      
      {/* Text rectangle - white with top-right and bottom-right radius */}
      <div className={`text-rectangle ${divClassName || ""} ${isFirstMessage ? 'startup-text' : ''}`}>
        {(() => {
          // 🔍 DEBUG: Log rendering conditions for initial message
          if (isFirstMessage) {
            console.log(`🎬 CEDARBUBBLE RENDER: showTyping=${showTyping}, enableTyping=${enableTyping}, shouldShowDots=${shouldShowDots}, shouldShowText=${shouldShowText}, text="${text}", status="${status}"`);
          }
          
          if (showTyping && enableTyping) {
            return shouldShowDots ? (
              <TypingIndicator className="cedar-typing-dots" />
            ) : shouldShowText ? (
              <TypingText 
                text={text} 
                speed={CEDAR_TYPING_SPEED}
                isStreaming={localIsStreaming}
                onComplete={handleAnimationComplete}
              />
            ) : null;
          } else if (showTyping) {
            return shouldShowText ? (text || (shouldShowFallback ? "Hello! How can I help you today?" : "")) : (
              shouldShowDots ? <TypingIndicator className="cedar-typing-dots" /> : null
            );
          } else {
            // showTyping should always be true now; this fallback just in case
            return null;
          }
        })()}
      </div>
    </div>
  );
};

// 🚀 PERFORMANCE FIX: Memoize CmpCedarbubble to prevent re-renders during streaming
// Every SSE chunk was causing ALL bubbles to re-render, creating performance issues
const MemoizedCedarBubble = React.memo(CmpCedarbubble, (prevProps, nextProps) => {
  // Only re-render if relevant props changed
  return (
    prevProps.text === nextProps.text &&
    prevProps.status === nextProps.status &&
    prevProps.isStreaming === nextProps.isStreaming &&
    prevProps.isFirstMessage === nextProps.isFirstMessage &&
    prevProps.enableTyping === nextProps.enableTyping &&
    prevProps.className === nextProps.className &&
    prevProps.divClassName === nextProps.divClassName &&
    prevProps.onAnimationComplete === nextProps.onAnimationComplete
  );
});

export { MemoizedCedarBubble as CmpCedarbubble };
